import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { About } from "@/components/site/About";
import { ContactBlock } from "@/components/site/ContactBlock";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <SmoothScroll>
      <main data-testid="landing-page" className="relative">
        <Nav />
        <Hero />
        <Ribbon />
        <About />
        <ContactBlock />
        <Footer />
      </main>
    </SmoothScroll>
  );
}
